import { combineReducers } from 'redux';
import filters from './filter/filter.reducer';
import filtersItems from './filterItems/filterItems.reducer';
import paginationData from './pagination/pagination.reducer';
import formularyData from './formulary/formulary.reducer';
import onboardFilters from './onboardFilters/onboardFilters.reducer';
import onboardStateFilters from './onboardStateFilters/onboardStateFilters.reducer';

const rootReducer = combineReducers({
  filters,
  filtersItems,
  paginationData,
  formularyData,
  onboardFilters,
  onboardStateFilters,
});

export default rootReducer;
